import styled, { css } from "styled-components";
import React, { useEffect, useState } from "react";
import { getLocale } from "react-i18nify";
import { device } from "src/styles/device";

import * as MatStyled from "@mui/material/styles";
import { useParams, useNavigate } from "react-router-dom";
import Forbidden from "src/pages/Forbidden";
import { Button, Grid, Alert, IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import { getSampleRequest, patchStatusSampleRequest } from "src/api/sample";
// import IconButton from "@mui/material/IconButton";
// import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
// import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ModalConfirm from "../ui/ModalConfirm";
import UploadImage from "../upload/dropzone/UploadImage";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { useAuth } from "src/hooks/useAuth";

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  position: relative;
  padding: 80px 120px;
  margin: auto;
  & > div > p {
    word-wrap: break-word;
  }
`;

const DivBackground = styled.div`
  width: 100%;
  padding: 32px;
  background-color: #f5f5f5;
  box-shadow: rgb(0 0 0 / 16%) 3px 4px 3px;
  border-radius: 30px;
  margin: 16px 0;
`;

const SpanTitle = styled.span`
  color: #000;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 16px;
`;

const SpanSubHeader = styled.p`
  color: rgb(106 106 109);
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 16px;
`;

const SpanContent = styled.p`
  color: #000;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 16px;
`;

const DivSample = styled.div`
  width: 100%;
`;

const WrapperProduct = styled.div`
  flex-direction: row;
  margin: 20px 0;
  display: flex;
`;

const WrapperTextField = styled.div`
  // margin-bottom: 16px;
  margin: auto;
  display: flex;
  justify-content: center;
  width: 75%;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    text-align: center;
    // background: #fff;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    text-align: center;
    border-radius: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }
`;

const ImgProduct = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 16px;
`;

const WrapperProductImage = styled.div`
  width: 130px;
  min-width: 130px;
  height: 130px;
  margin: 12px;
`;

const WrapperDesc = styled.div`
  width: 50%;
  display: block;
  margin: auto;
`;

const ProductName = styled.p`
  font-size: 1rem;
  width: 80%;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ProductCode = styled.p`
  font-size: 0.75rem;
  width: 80%;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ProductCate = styled.p`
  width: 80%;
  font-size: 0.75rem;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ProductType = styled.p`
  font-size: 0.75rem;
  font-weight: 400;
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const WrapperAlert = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  @keyframes showAlert {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;

const WrapperCalSam = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* margin: 20px 0 0;
  
  @media ${device.mobile} {
    margin: 10px 0 10px 0;
  } */
`;

const RowSumPrice = styled.div`
  margin-left: 0;
  margin-right: 0;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 20px; */
  display: flex;
`;

const Price = styled.span`
  color: ${({ desc }) => (desc ? "#252525" : "#E13B30")};
  font-size: 1.25rem;
  font-weight: 400;
  text-align: ${(props) => (props.align ? props.align : "left")};

  ${({ desc }) =>
    desc &&
    css`
      font-size: 1rem;
    `}

  @media ${device.tablet} {
    font-size: 0.75rem;
  }
  @media ${device.tablet} {
    font-size: 0.625rem !important;
  }
`;

const WrapperOutPrice = styled.div`
  width: 100%;
  max-width: 170px;

  .MuiOutlinedInput-root {
    border-radius: 16px;
    font-size: 1.25rem;
    color: #e13b30;
    position: relative;

    ::before {
      content: "฿";
      position: absolute;
      left: 14px;
      color: #6c6c70;
    }
  }
  .MuiOutlinedInput-input {
    background: #fff;
    text-align: center;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
    min-height: 200px;
  }
`;

const RowDownloadDoc = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 24px;
`;

const WrapperDownloadDoc = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const WrapperAttachSlip = styled.div`
  width: 350px;
  height: auto;
  min-height: 350px;
  margin: 30px auto 0;
  background: #ffffff;
  border: 1px dashed #d9d9d9;
  border-radius: 24px;
  position: relative;
  /* display: flex;
  justify-content: center;
  align-items: center; */
`;

const SpanAttachSlip = styled.span`
  position: absolute;
  top: -10px;
  left: 12px;
  font-size: 0.75rem;
  font-weight: 400;
  color: #6c6c70;
  padding: 0 4px;
  background: #ffffff;
`;

const WrapperUploadImage = styled.div`
  width: 350px;
  min-height: 350px;
  padding: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrapperImgSlip = styled.div`
  width: 100%;
  max-width: 300px;
  height: auto;
`;

const ImgSlip = styled.img`
  width: 100%;
  height: 100%;
  /* max-height: 300px; */
  object-fit: contain;
`;

const WrapperTextNote = styled.div`
  // margin-bottom: 16px;
  margin: auto;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;

  .MuiOutlinedInput-root {
    border-radius: 16px;
    font-size: 1rem;
  }
  .MuiOutlinedInput-input {
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
    min-height: 200px;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const SampleDetail = ({ open }) => {
  const { user, checkAllowPermission } = useAuth();
  let { sampleId } = useParams();
  const navigate = useNavigate();

  const [sampleDetail, setSampleDetail] = useState({});
  const [isVisible, setIsVisible] = useState(false);

  const [isVisibleConfirmApprove, setIsVisibleConfirmApprove] = useState(false);
  const [textError, setTextError] = useState("");
  const [typeError, setTypeError] = useState("success");
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    if (sampleId === undefined) return;
    (async () => {
      await getSampleRequest(sampleId)
        .then(async ({ data }) => {
          setSampleDetail({
            ...data,
            product_choice_samples: data.product_choice_samples.map(
              (product) => ({
                ...product,
                sample_price:
                  product.sample_price === null ||
                  product.sample_price === undefined
                    ? (product.product_choice_sample?.group_price
                        ?.sample_price ?? 0)
                    : product.sample_price,
              }),
            ),
            pay_slip_image: data?.pay_slip_image ?? "",
            note: data?.note ?? "",
          });
        })
        .catch((err) => {
          console.log("error", err.response.data.message);
          navigate("/404");
        });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sampleId]);
  // console.log("sampleDetail", sampleDetail);

  const calcTotalPrice = (sampleChoice) => {
    let total = 0;
    sampleChoice?.forEach((prod) => {
      total += prod.volume * prod.sample_price;
    });
    setTotalPrice(total);
  };

  useEffect(() => {
    calcTotalPrice(sampleDetail?.product_choice_samples);
  }, [sampleDetail?.product_choice_samples]);

  const productSampleList = () => {
    return sampleDetail?.product_choice_samples?.map((sample, index) => {
      return (
        <WrapperProduct key={`sample-product` + index}>
          <Grid item xs={3} sx={{ display: "flex" }}>
            <WrapperProductImage>
              <ImgProduct
                src={sample?.product_choice_sample?.group_image?.product_display_image.replace(
                  ".com",
                  ".com/300x300",
                )}
                alt={
                  sample?.product_choice_sample?.group_image
                    ?.product_display_image
                }
              />
            </WrapperProductImage>
            <WrapperDesc>
              <ProductName>
                {sample?.product_choice_sample?.product?.item_name}
              </ProductName>
              <ProductCode>
                {sample?.product_choice_sample?.product?.item_code}
              </ProductCode>
              <ProductCate>
                {getLocale() === "th"
                  ? sample?.product_choice_sample?.product?.category?.cate_th
                  : sample?.product_choice_sample?.product?.category?.cate_en}
              </ProductCate>
              <ProductType>
                {getLocale() === "th"
                  ? sample?.product_choice_sample?.product?.product_types
                      .map(({ type_th }) => type_th)
                      .join(", ")
                  : sample?.product_choice_sample?.product?.product_types
                      .map(({ type_en }) => type_en)
                      .join(", ")}
              </ProductType>
            </WrapperDesc>
          </Grid>
          <Grid item xs={3} sx={{ display: "flex" }}>
            <WrapperTextField>
              <TextField
                className="TextField-without-border-radius"
                InputProps={{
                  readOnly: sampleDetail.status === 1 ? true : false,
                  // startAdornment: (
                  //   <IconButton
                  //     id="button-del-volume"
                  //     sx={{ padding: 0 }}
                  //     onClick={() => {
                  //       console.log("----");
                  //     }}
                  //   >
                  //     <RemoveCircleRoundedIcon
                  //       sx={{
                  //         color: "#e04132",
                  //         cursor: "pointer",
                  //       }}
                  //     />
                  //   </IconButton>
                  // ),
                  // endAdornment: (
                  //   <IconButton
                  //     id="button-add-volume"
                  //     sx={{ padding: 0 }}
                  //     onClick={() => {
                  //       console.log("+++++");
                  //     }}
                  //   >
                  //     <AddCircleRoundedIcon
                  //       sx={{ color: "#e04132", cursor: "pointer" }}
                  //     />
                  //   </IconButton>
                  // ),
                }}
                sx={{ margin: "auto", width: "80%", textAlign: "center" }}
                value={sample?.volume ? sample?.volume : 1}
                onChange={(e) => {
                  if (e.target.value * 0 === 0) {
                    const dataSample = sampleDetail.product_choice_samples;
                    dataSample[index].volume = e.target.value;
                    setSampleDetail({
                      ...sampleDetail,
                      product_choice_samples: [...dataSample],
                    });
                  }
                }}
              />
            </WrapperTextField>
          </Grid>
          <Grid item xs={3} sx={{ display: "flex" }}>
            <WrapperTextField>
              <TextField
                className="TextField-without-border-radius"
                InputProps={{
                  readOnly: sample.status === 1 ? true : false,
                }}
                sx={{ margin: "auto", width: "80%", textAlign: "center" }}
                value={
                  (sample?.sample_price === 0 ||
                    sample?.sample_price === "0" ||
                    sample?.sample_price === null) &&
                  sampleDetail.status === 1
                    ? getLocale() === "th"
                      ? "ฟรี"
                      : "Free"
                    : sample?.sample_price
                }
                onChange={(e) => {
                  if (e.target.value * 0 === 0) {
                    const dataSample = sampleDetail.product_choice_samples;
                    dataSample[index].sample_price = e.target.value;
                    setSampleDetail({
                      ...sampleDetail,
                      product_choice_samples: [...dataSample],
                    });
                  }
                }}
              />
            </WrapperTextField>
          </Grid>
          <Grid item xs={3} sx={{ display: "flex" }}>
            <WrapperTextField>
              <Select
                className="TextField-without-border-radius"
                id="status-input"
                disabled={sampleDetail.status === 0 ? false : true}
                value={sample.status}
                sx={{ margin: "auto", width: "80%", textAlign: "center" }}
                onChange={(e) => {
                  const dataSample = sampleDetail.product_choice_samples;
                  dataSample[index].status = e.target.value;
                  setSampleDetail({
                    ...sampleDetail,
                    product_choice_samples: [...dataSample],
                  });
                }}
              >
                <MenuItem value={1}>Approve</MenuItem>
                <MenuItem value={0}>Pending</MenuItem>
                <MenuItem value={2}>Reject</MenuItem>
              </Select>
            </WrapperTextField>
          </Grid>
        </WrapperProduct>
      );
    });
  };
  const handleApprove = () => {
    if (
      sampleDetail.product_choice_samples.find(
        (product) => product.status === 0,
      )
    ) {
      setTextError(`กรุณาเพิ่มสถานะการอนุมัติให้ครบถ้วน`);
      setTypeError("error");
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 1500);
      return;
    } else if (totalPrice !== 0 && sampleDetail.pay_slip_image === "") {
      setTextError(`กรุณาอัพโหลดหลักฐานการชำระ`);
      setTypeError("error");
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 1500);
      return;
    } else {
      // const params =
      // {
      //   sample: sampleDetail?.product_choice_samples.map((product) => {
      //     product.sample_id = sampleDetail.id;
      //     return product;
      //   }),
      // };
      // const params = null;

      let data = new FormData();
      const { pay_slip_image, ...sampleData } = sampleDetail;

      const sampleDataParams = {
        ...sampleData,
        ...(pay_slip_image !== "" ? { pay_slip_image } : {}),
      };

      Object.keys(sampleDataParams).forEach((key) => {
        if (Array.isArray(sampleDataParams[key])) {
          data.append(key, JSON.stringify(sampleDataParams[key]));
        } else {
          data.append(key, sampleDataParams[key]);
        }
        return data;
      });

      patchStatusSampleRequest(data)
        .then((res) => {
          setIsVisibleConfirmApprove(false);
          setTextError(`อนุมัติเอกสารสำเร็จ`);
          setTypeError("success");
          setIsVisible(true);
          setTimeout(() => {
            setIsVisible(false);
            (async () => {
              await getSampleRequest(sampleId)
                .then(async ({ data }) => {
                  // setSampleDetail(data);
                  setSampleDetail({
                    ...data,
                    product_choice_samples: data.product_choice_samples.map(
                      (product) => ({
                        ...product,
                        sample_price:
                          product.sample_price === null ||
                          product.sample_price === undefined
                            ? (product.product_choice_sample?.group_price
                                ?.sample_price ?? 0)
                            : product.sample_price,
                      }),
                    ),
                    pay_slip_image: data?.pay_slip_image ?? "",
                    note: data?.note ?? "",
                  });
                })
                .catch((err) => {
                  console.log("error", err.message);
                });
            })();
          }, 1500);
        })
        .catch((err) => {
          setIsVisibleConfirmApprove(false);
          setTextError(err.response.data.message);
          setTypeError("error");
          setIsVisible(true);
          setTimeout(() => {
            setIsVisible(false);
          }, 1500);
        });
    }
  };

  if (user?.role_id === 3 || user?.role_id === 4) return <Forbidden />;

  return (
    <Main
      sx={{ width: "100%", marginTop: "75px", background: "#fff" }}
      open={open}
    >
      <Container>
        <SpanTitle>
          {getLocale() === "th"
            ? "รายละเอียดใบขอสินค้าตัวอย่าง"
            : "Sample request detail"}
        </SpanTitle>

        <Grid container spacing={4}>
          <Grid item xs={12} sx={{ margin: "0 auto" }}>
            <DivBackground>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "เลขที่เอกสาร " : "Document No. "}
                  </SpanSubHeader>
                  <SpanContent>{sampleDetail?.running_number}</SpanContent>
                </Grid>

                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "สถานะเอกสาร " : "Status "}
                  </SpanSubHeader>
                  <SpanContent>
                    {sampleDetail?.status === 0
                      ? "Pending"
                      : sampleDetail?.status === 1
                        ? "Approve"
                        : sampleDetail?.status === 2
                          ? "Reject"
                          : "-"}
                  </SpanContent>
                </Grid>
              </Grid>

              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "ชื่อ-นามสกุล" : "Full name"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sampleDetail?.full_name ? sampleDetail?.full_name : "-"}
                  </SpanContent>
                </Grid>
                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "ชื่อโครงการ" : "Full name"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sampleDetail?.project ? sampleDetail?.project : "-"}
                  </SpanContent>
                </Grid>
              </Grid>

              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "เลขที่ภาษี" : "Tax Number"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sampleDetail?.tax_id ? sampleDetail?.tax_id : "-"}
                  </SpanContent>
                </Grid>
                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "เบอร์โทรศัพท์" : "Phone Number"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sampleDetail?.phone_number
                      ? sampleDetail?.phone_number
                      : "-"}
                  </SpanContent>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "อีเมล" : "E-mail"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sampleDetail?.email ? sampleDetail?.email : "-"}
                  </SpanContent>
                </Grid>
                <Grid item xs={6}>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "ที่อยู่" : "Address"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sampleDetail?.address ? sampleDetail?.address : "-"}
                  </SpanContent>
                </Grid>
              </Grid>
            </DivBackground>
          </Grid>
          <Grid item xs={12}>
            <SpanTitle>
              {getLocale() === "th"
                ? "สินค้าในคำขอตัวอย่างนี้"
                : "สินค้าในคำขอตัวอย่างนี้"}
            </SpanTitle>
            <DivSample>
              <WrapperProduct>
                <Grid
                  item
                  xs={3}
                  sx={{
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "1.25rem",
                  }}
                >
                  {getLocale() === "th" ? "สินค้า" : "Product"}
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "1.25rem",
                  }}
                >
                  {getLocale() === "th" ? "จำนวน" : "Quantity"}
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "1.25rem",
                  }}
                >
                  {getLocale() === "th" ? "ราคา" : "Price"}
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "1.25rem",
                  }}
                >
                  {getLocale() === "th" ? "สถานะ" : "Status"}
                </Grid>
              </WrapperProduct>
            </DivSample>
            <DivSample style={{ borderBottom: "1px solid #D9D9D9" }}>
              {productSampleList()}
            </DivSample>
          </Grid>

          <Grid item xs={12}>
            <WrapperCalSam>
              <RowSumPrice>
                <Price desc>
                  {getLocale() === "th" ? "ยอดรวมทั้งหมด" : "Subtotal"}
                </Price>

                <WrapperOutPrice>
                  <TextField
                    id="balance-input"
                    label={
                      getLocale() === "th" ? "ยอดรวมทั้งหมด" : "Deposit price"
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                    value={totalPrice}
                  />
                </WrapperOutPrice>
              </RowSumPrice>
            </WrapperCalSam>
          </Grid>

          {/* payment slip */}
          {sampleDetail.status === 1 && sampleDetail?.pay_slip_image !== "" && (
            <Grid item xs={12}>
              <SpanTitle>
                {getLocale() === "th" ? "หลักฐานการชำระ" : "Payment slip"}
              </SpanTitle>

              <RowDownloadDoc>
                <WrapperDownloadDoc>
                  <WrapperImgSlip>
                    <ImgSlip
                      src={sampleDetail?.pay_slip_image}
                      alt="pay_slip_image"
                    />
                  </WrapperImgSlip>

                  <Button
                    onClick={() => {
                      window.open(`${sampleDetail?.pay_slip_image}`, "_blank");
                    }}
                    style={{
                      backgroundColor: "#ffffff",
                      color: "#e04132",
                      border: "1px solid #d9d9d9",
                      borderRadius: "16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "8px 16px",
                      minWidth: "120px",
                      fontSize: "0.875rem",
                    }}
                  >
                    <DownloadIcon />
                    {getLocale() === "th" ? "ดาวน์โหลด" : "Download"}
                  </Button>
                </WrapperDownloadDoc>
              </RowDownloadDoc>
            </Grid>
          )}

          {/* upload sample price slip */}
          {sampleDetail.status === 0 && totalPrice !== 0 && (
            <Grid item xs={12}>
              <SpanTitle>
                {getLocale() === "th" ? "หลักฐานการชำระ" : "หลักฐานการชำระ"}
              </SpanTitle>

              <WrapperAttachSlip>
                <SpanAttachSlip>แนบหลักฐานการชำระเงิน</SpanAttachSlip>

                {sampleDetail.pay_slip_image !== "" && (
                  <IconButton
                    sx={{
                      padding: "3px",
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      zIndex: 10,
                      backgroundColor: "#d9d9d999",
                      ":hover": {
                        backgroundColor: "#d9d9d9db",
                      },
                    }}
                    onClick={() => {
                      const dataUp = sampleDetail;
                      dataUp.pay_slip_image = "";
                      setSampleDetail({ ...dataUp });
                    }}
                  >
                    <CloseIcon
                      sx={{
                        color: "#e04132",
                        cursor: "pointer",
                      }}
                    />
                  </IconButton>
                )}

                <UploadImage
                  callBackFile={(fileCallBlack) => {
                    const dataUp = sampleDetail;
                    dataUp.pay_slip_image = fileCallBlack;
                    fileCallBlack !== "" && setSampleDetail({ ...dataUp });
                  }}
                  closeAlert={false}
                >
                  {sampleDetail?.pay_slip_image === "" ? (
                    <WrapperUploadImage>
                      <Button
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#e04132",
                          border: "1px solid #d9d9d9",
                          borderRadius: "16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "8px 16px",
                          minWidth: "120px",
                          fontSize: "0.875rem",
                        }}
                      >
                        <AddCircleIcon />
                        {getLocale() === "th"
                          ? "เลือกรูปจากเครื่องของคุณ"
                          : "Select image"}
                      </Button>
                    </WrapperUploadImage>
                  ) : (
                    <WrapperUploadImage>
                      <WrapperImgSlip>
                        <ImgSlip
                          src={sampleDetail?.pay_slip_image?.fileData}
                          alt={sampleDetail?.pay_slip_image?.path}
                        />
                      </WrapperImgSlip>
                    </WrapperUploadImage>
                  )}
                </UploadImage>
              </WrapperAttachSlip>
            </Grid>
          )}

          {/* Note */}
          <Grid item xs={12}>
            <SpanTitle>{getLocale() === "th" ? "โน๊ต" : "Note"}</SpanTitle>
            <WrapperTextNote>
              <TextField
                id="note-input"
                label={getLocale() === "th" ? "โน๊ต" : "Note"}
                fullWidth
                multiline
                rows={6}
                onChange={(e) => {
                  setSampleDetail({
                    ...sampleDetail,
                    note: e.target.value,
                  });
                }}
                value={sampleDetail.note}
                InputProps={{
                  readOnly: sampleDetail?.status === 1 ? true : false,
                }}
              />
            </WrapperTextNote>
          </Grid>

          {checkAllowPermission("orders.can_approve_sampleRequest") && (
            <Grid item xs={12}>
              <Button
                disabled={sampleDetail.status === 0 ? false : true}
                onClick={() => setIsVisibleConfirmApprove(true)}
                className="Button-New-Brand"
                style={{
                  background: sampleDetail.status === 0 ? "#e04132" : "gray",
                  color: "#fff",
                  borderRadius: "16px",
                  margin: "32px auto",
                  display: "flex",
                  width: "120px",
                  height: "42px",
                }}
              >
                อนุมัติ
              </Button>
            </Grid>
          )}
        </Grid>

        {isVisibleConfirmApprove ? (
          <ModalConfirm
            title={
              getLocale() === "th"
                ? `ต้องการอนุมัติคำขอหรือไม่ ?`
                : `Want to approve document?`
            }
            callBack={(value) =>
              value === false
                ? setIsVisibleConfirmApprove(value)
                : handleApprove()
            }
            textConfirm={"confirm"}
          />
        ) : null}
        {isVisible && (
          <WrapperAlert>
            <DivAlert>
              <Alert
                className="MuiPaper-root-MuiAlert-root"
                severity={typeError}
              >
                {textError}
              </Alert>
            </DivAlert>
          </WrapperAlert>
        )}
      </Container>
    </Main>
  );
};
export default SampleDetail;
